import { z } from 'zod';
// Demo Configuration Types
export const DemoConfigSchema = z.object({
    id: z.string(),
    userId: z.string(),
    title: z.string(),
    description: z.string(),
    businessDomain: z.string(),
    agents: z.array(z.object({
        id: z.string(),
        name: z.string(),
        role: z.string(),
        avatar: z.string(),
        expertise: z.array(z.string()),
        personality: z.string(),
        dataSources: z.array(z.string()),
        bedrockModel: z.string(),
        instructions: z.string(),
        tools: z.array(z.object({
            name: z.string(),
            description: z.string(),
            parameters: z.record(z.string(), z.any()),
        })),
    })),
    scenarios: z.array(z.object({
        id: z.string(),
        title: z.string(),
        description: z.string(),
        exampleQueries: z.array(z.string()),
        expectedFlow: z.array(z.object({
            agentId: z.string(),
            action: z.string(),
            message: z.string(),
        })),
    })),
    uiConfig: z.object({
        theme: z.object({
            primaryColor: z.string(),
            secondaryColor: z.string(),
            backgroundColor: z.string(),
            textColor: z.string(),
        }),
        branding: z.object({
            logo: z.string().optional(),
            companyName: z.string(),
            tagline: z.string().optional(),
        }),
        layout: z.object({
            showAgentAvatars: z.boolean(),
            showReasoningSteps: z.boolean(),
            enableChat: z.boolean(),
        }),
        customCSS: z.string().optional(),
    }),
    isPublic: z.boolean(),
    status: z.enum(['draft', 'published', 'archived']),
    publicUrl: z.string().optional(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
//# sourceMappingURL=demo.js.map